// common
export const PUT_REQUEST = 'appointmentCustodian/PUT_REQUEST'
export const PUT_SUCCESS = 'appointmentCustodian/PUT_SUCCESS'
export const PUT_FAILURE = 'appointmentCustodian/PUT_FAILURE'